<template>
    <div
        ref="loadingSpinner"
        class="sbs-video-player-loading-spinner">
        <SbsSpinner
            class="sbs-video-player-loading-spinner__icon"
            :colorTheme="colorTheme"
            :size="fullscreenSpinnerSize" />
    </div>
</template>

<script>
import videojs from 'video.js';
import { toRaw } from 'vue';
import { AllColors } from '../../../utils/colors.js';
import { AllSizes } from '../../../utils/sizes.js';
import SbsSpinner from '../../spinner/SbsSpinner.vue';

export default {
    name: 'SbsVideoPlayerLoadingSpinner',
    comments: {
        SbsSpinner,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        fullscreenSpinnerSize() {
            return this.player.isFullscreen()
                ? AllSizes.LARGE
                : AllSizes.MEDIUM;
        },
    },
    props: {
        colorTheme: {
            type: String,
            default: AllColors.CURRENT_COLOR,
        },
    },
    mounted() {
        const LoadingSpinner = videojs.getComponent('loadingSpinner');
        const loadingSpinnerComponent = new LoadingSpinner(this.player);
        const loadingSpinner = this.player.addChild('ClickableComponent', {
            el: this.$refs.loadingSpinner,
        });

        loadingSpinner.addChild(loadingSpinnerComponent);
    },
};
</script>

<style lang="scss">
.sbs-video-player-loading-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    display: none;
    width: 120px;
    height: 120px;
    background-color: rgba($black, 0.65);
    border: none;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    content: "";

    .vjs-fullscreen & {
        width: 150px;
        height: 150px;
    }

    .vjs-waiting:not(.vjs-forward-seeking):not(.vjs-backward-seeking) & {
        display: block;
    }

    &__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        transform: translate(-50%, -50%);
    }

    .vjs-loading-spinner {
        border: none;
    }
}

// отключение страндартного спиннера
.vjs-loading-spinner {
    .vjs-seeking &,
    .vjs-waiting &,
    &::before,
    &::after {
        display: none;
    }
}
</style>
